import React, { forwardRef } from "react";
// @ts-expect-error - this will be resolved at build time
import { Box, Text } from "@xsolla/xui-primitives";

interface PeriodToggleProps {
  value: "am" | "pm";
  onChange: (value: "am" | "pm") => void;
  disabled?: boolean;
  fontSize: number;
  textColor: string;
  testID?: string;
}

export const PeriodToggle = forwardRef<HTMLElement, PeriodToggleProps>(
  ({ value, onChange, disabled = false, fontSize, textColor, testID }, ref) => {
    const toggle = () => {
      if (!disabled) {
        onChange(value === "am" ? "pm" : "am");
      }
    };

    const handleKeyDown = (e: any) => {
      if (disabled) return;
      const key = (e.key || e.nativeEvent?.key || "").toLowerCase();
      if (key === "a") {
        e.preventDefault();
        onChange("am");
      } else if (key === "p") {
        e.preventDefault();
        onChange("pm");
      }
    };

    return (
      <Box
        ref={ref}
        as="button"
        type="button"
        onPress={toggle}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        cursor={disabled ? "default" : "pointer"}
        justifyContent="center"
        alignItems="center"
        marginLeft="auto"
        paddingHorizontal={4}
        backgroundColor="transparent"
        borderWidth={0}
        role="switch"
        aria-checked={value === "pm"}
        aria-disabled={disabled || undefined}
        aria-label={value.toUpperCase()}
        data-testid={testID}
      >
        <Text color={textColor} fontSize={fontSize} fontWeight="400">
          {value}
        </Text>
      </Box>
    );
  }
);

PeriodToggle.displayName = "PeriodToggle";
